var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 95,
    height: 95,
    rx: 47.5,
    fill: "#FBE8F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 22.25,
    width: 45,
    height: 45,
    fill: "url(#pattern0_46_950)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_46_950",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_46_950",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_46_950",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFi0lEQVR4nO2ca2hcRRTHL1qtT1DaZM+5Gw1oVPCtBfGNqCAqPhCC4KuY7DmbxKRSRFBRIvilH/3glxYFP2kpvimoiAaL74qpNd2d2bVUS634qFXbKpLYyOxug9nM3ex95d6dO3+YL5uZM3d+98y5Z+ZOruNYWVlZWVlZWVlZWVlZWVlZWTm7elcfV0Z6WCB9LpEPSuRZowrQb2UsrEr0VlfyhR4J/HXiMNBgyMqTLeQlkAoXiXscGuzJR9SIyclDQYMhK0mkA4lDwWiLAN4vc8XLnDQpaSgyBZ68JJ6fGi9EWq8gJQFZtXPiViogA4/XrsUtXCyBfl2qcFFxhy6RwPtUeydupQXyEQWBHRay8aBFE+QgsKOAbDRo4QHZD+yoIBsLWiwCeT4UPewoIRsJWiCtD5IVRJVdeF2XE7cS8Ob9wTyx7tlRe7KxoGUIWAJpZxyQjQUtA07/Lx0+JspwkQ3QGO+eRLuenAnQMibYfiFnArSMGHYQyJkBLSOCHRRypkDLkLDDQM4caFlb0PDvcaVwFjQGhx0F5Ex6tPQBOyrImQYtF4EdJeTMg5YesKOGbEHjQs+OA7IFjU17Iy4NhH6Ba0Fzos+DTD8MpQXNiYPJmkd/J5HfF8ivqCKRPxBAe5KGZgZooIo6gVpayehlcwcM9EqkxwXQ7qQBdhxogXxYID0zdW7/se3a3pa770QJ/GzSEDsLNNBI4D5y/GjSIDsCtIq/YfsRwK8lDTP1oMvdfIGu7Y588SwBvEEifyGRtkrgF6q5wnla0PnBC5OGmWrQAriqa1daySiQf9bU/1sgX63tC1j6GXzNFtBXEultgbxZIH9WezlgImgJ/I6uXRkL97Zqs/304VObi/q9rYEDf1x26fYfkE9o7nfW6T+60l24XAC9JJD+NQa0V3yW6hAi0nS0nkXTfh665VzxuqDnqdMHGniLV1vh8g3q7wJ5JorBqlni9/rVIRkVYgwATX/ppvD/VQ8LxVsk8JMC6dUgq0OB/KKj0YQzvkxtjZZdurK8YuBkXR2B/FjHg26UMd92u4fPUAAE8PdtQJ6p9gz2NduodPGZEnn7XF3gX9Qsaq6nbkDYh2QYhu0Bae9C/izlhs4P/p+5tE6tLL3t04T+2mhCM8P26M7gSaCNJoBW3rRPZQIh+nmiBeindeHI8+bkixcttE+jZoCem+b0oQC6f2f3YM5PP7PO+FES6RutTZfvDjsOgXynUaDnezlVBPDLtb0M4GsrfWPLA+15uHRj+HEUrjEXNDbHTz4kgZ6vwINdur5ErnC9rp3Kh8OOo+ryFZkBLRdfTa7yqH+XNmsBfq/dUt9v6WDQAujm5qV0pf4hlX9ahRQP0Dd5gH6kue5U18hJrTOVaEvioCUUH/Bot6YFiDW6NgJorQfoN7X1kTfr7dNWibxpfqn91smg+XWvtpXa5g5vUMvw2tQF2qhmgGdfQB/pZw0f0sX1qjt8mgD6pAnyxK7e1acsHAc919mgkaaryJeG7ifHt7a+obTOKy0suYWzVWaiWz0qldyHVtROM3U26NoSuTTVNQJB+yi7Q+dI5L2L9DGjW163lZ8DvREGcmpAN6Z3VWDxKr/2Ky7fJpF+bLOfgwK4v13bKoSo0BYWcqpAN7zusPIegcU7VFbgZbOWmSDfo855BBm0AH5XZSi7e9Yer7OvQogAfiqqvejUgW6e6hK43MhhNzUO0KjDNN9GNfj6qyyeVOAF0Fv1vW/6KSr7HQFaGlYsaDQGtHmfY5M+i0D6I3bQxn5gEP2A5k9jB62Wy0kPVCZeaDR20GoPWQBty6w3A0/6ObgZDna+0JNF2AJ4UvYU80sCeQ5239hy9bZbxSuzH5B0oL5RRaNL5slWVlZWVlZWVlZWVlZWVlZWTrr1Hy97DmQGmpk6AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4);
export default __webpack_public_path__ + "static/media/s4.b22c7867c1f6ff7397ae6b2acf010ef1.svg";
export { ForwardRef as ReactComponent };